import styled from 'styled-components';

export const SelectorContainer = styled.div`
   display: flex;
   flex-direction: column;
`;

// Container for the package window
export const McPackageWindow = styled.div`
  display: flex;
  justify-content: flex-start;
  width: max-content;
`;


// Title and duration container
export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TitleText = styled.p`
  font-size: 20px;
  font-weight: bold;
  color: black;
  margin-right: 8px;
`;


// Container for dham details
export const Dham = styled.div`
  margin-top: 10px;
`;

export const VerticalFlex = styled.div`
   display: flex;
    align-items: center;
`;

export const HrLine = styled.div`
    border: 1px dashed #e7e7e7;
    width: 100%;
`

export const BookCabContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 10px;
`;

export const BookCabStyle = styled.div`
    display: flex;
    justify-content: center;
    margin-right: 5px;
    flex-direction: column;
`;

// Price text for supplementary information
export const PriceTextSup = styled.div`
  text-wrap: nowrap;
  font-size: 14px;
  padding-bottom: 5px;
  margin-right: 5px;
`;

// Price container
export const Price = styled.div`
    font-size: 16px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
`;

export const PriceText = styled.span`
    font-size: 14px;
    font-weight: bold;
`;

export const CabTypeText = styled.span`
  text-wrap: nowrap;
  font-size: 16px;
  align-self: center;
  padding-left: 4px;
  color: #757575;
`;

// Box image used for cab types
export const BoxImage = styled.img`
  width: 76px;
  height: 40px;
  margin-right: 16px;
  border-radius: 8px;
`;

// Flex Container
export const MakeFlex = styled.div`
  display: flex;
`;

// Package Selector
export const McPackageSelector = styled.div`
  padding: 0 0 25px 0;
`;

// Card
export const Card = styled.div`
  margin-right: 20px;
  min-width: 315px !important;
  background-color: white;
  height: inherit;
  padding: 16px;
  border-radius: 16px;
  padding-bottom: 0px;
  &:hover {
    cursor: pointer;
  }
  &:last-child {
    margin-right: 0;
  }
`;

// Card Info
export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const CarInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const CarName = styled.div`
  font-weight: bold;
`;

export const CarSeats = styled.div`
  color: #4a4a4a;
`;

// Padding
export const Padding5 = styled.div`
  padding: 5px;
`;

// Package Image
export const McPackageImage = styled.img`
  width: 298px !important;
  border-radius: 20px;
  height: 175px !important;
  margin-bottom: 12px;
`;

// Justify Content Start
export const JustifyAtStart = styled.div`
  justify-content: flex-start;
`;

// Package Scroller
export const McPackageScroller = styled.div`
  overflow-x: scroll;
  display: flex;
  scroll-behavior: smooth;

    scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none;  /* For Internet Explorer and Edge */
  
  &::-webkit-scrollbar {
    display: none;  /* For Chrome, Safari, and Opera */
  }
`;

// Duration
export const Duration = styled.span`
  border: 1px solid #cf8100;
  background-color: #ffedd1;
  border-radius: 8px;
  color: #cf8100;
  padding: 4px 6px;
  margin-left: auto;
  text-wrap: nowrap;
`;

// Dotted Horizontal Line
export const DottedHorizontalLine = styled.div`
  border: 1px dashed #e7e7e7;
  width: 100%;
`;

// View Cab Button
export const ViewCab = styled.div`
  width: 120px;
  height: 40px;
  background-color: #FF6D38;
  border-radius: 24px;
  margin-left: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ViewCabText = styled.p`
  color: white;
  font-size: 14px;
  font-weight: 700;
`

// Dham Selector
export const DhamSelector = styled.div`
  display: inline-flex;
  align-items: center;
  border: 0.5px solid #d8d8d8;
  border-radius: 12px;
  background-color: white;
  overflow: hidden;
`;

// Cab Type Selector
export const CabTypeSelector = styled.div`
  display: flex !important;
  width: fit-content;
  gap: 16px;
`;

// Dham Button
export const DhamButton  = styled.div<{ selected: boolean; isLast: boolean }>`
  padding: 16px 52px;
  cursor: pointer;
  border: ${(props) => (props.selected ? '1px solid #008cff' : 'none')};
  border-radius: ${(props) => (props.selected ? '12px' : '0')};
  color: ${(props) => (props.selected ? '#008cff' : '#4a4a4a')};
  font-weight: bold;
  background-color: ${(props) => (props.selected ? '#eaf5ff' : 'white')};
    ${(props) =>
    !props.selected && props.isLast &&
    `
    border-right: 1px solid #ddd;
  `}
  @media (max-width: 1295px) {
      padding:16px 32px;
  }
`;

// Left Right Scroll Padding
export const LeftRightScrollPadding = styled.div`
  padding-left: 200px !important;
  padding-right: 0 !important;
`;

// Cab Button
export const CabButton = styled.div<{ selected: boolean; isLast: boolean }>`
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-width: 1px;
  border-style: solid;
  border-radius: 12px;
  width: 220px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative; 
  box-sizing: border-box;
  background-color: ${(props) => (props.selected ? '#E5F3FF' : 'white')};
  border-color: ${(props) => (props.selected ? '#008cff' : '#d8d8d8')};
  cursor: pointer;
`;

// Selected Style
export const Selected = styled.div`
  color: #008cff;
  border: 1px solid #008cff;
  border-radius: 8px;
`;

// Selectors
export const Selectors = styled.div`
  margin-bottom: 22px;
  display: flex;
  height: 55px;
  justify-content: space-between;
`;

// Why Choose Us Container
export const WhyChooseUsContainer = styled.div`
  background-color: white;
  padding: 40px 200px;
  justify-content: space-between;
  display: flex;
  width: 100%;
`;

// Why Choose Us
export const WhyChooseUs = styled.div`
  width: 584px;
  padding-left: 12px;
`;

// Why Book With Us Points
export const WhyBookWithUsPoints = styled.div`
  display: flex;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  padding: 9px 20px 9px 0;
`;

// Why Choose Us Info
export const WhyChooseUsInfo = styled.div`
  padding-left: 10px;
`;

// Assistance Container
export const Assistance = styled.div`
  background-color: #16477f;
  padding: 24px;
  border-radius: 32px;
`;

// Assistance Title
export const AssistanceTitle = styled.h2`
  font-size: 24px;
  font-weight: 900;
  color: white;
  padding-bottom: 8px;
`;

// Assistance Button
export const AssistanceButton = styled.button`
  width: 190px;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(91.67deg, #53b2fe 0%, #065af3 100%);
  color: white;
  font-size: 16px;
  font-weight: 900;
  
  &:hover {
    cursor: pointer;
  }
`;

// Assistance Info
export const AssistanceInfo = styled.div`
  padding: 0 18px;
  display: grid;
`;

// Route Image
export const RouteImg = styled.div`
  padding: 20px 200px;
  width: 100%;
  background-color: white;
`;

// Itinerary Container
export const Itinerary = styled.div`
  padding: 30px 200px;
`;

// Itinerary Title
export const ItineraryTitle = styled.h2`
  font-size: 24px;
  font-weight: 900;
  color: black;
  margin-bottom: 20px;
`;

// Itinerary Info
export const ItineraryInfo = styled.div`
  display: flex;
  border-radius: 16px;
  padding: 10px 20px;
  margin-bottom: 20px;
  background-color: white;
  
  &:hover {
    cursor: pointer;
  }
`;

// Itinerary Route
export const ItineraryRoute = styled.div`
  padding: 0;
  font-size: 18px;
  font-weight: 900;
  color: black;
`;

// Itinerary Distance
export const ItineraryDistance = styled.div`
  padding: 4px 0;
  font-size: 16px;
  font-weight: 400;
  color: #757575;
`;

// Itinerary Duration
export const ItineraryDuration = styled.div`
  padding: 4px 0;
  font-size: 16px;
  font-weight: 400;
  color: #757575;
  padding-left: 20px;
`;

// Itinerary Details
export const ItineraryDetails = styled.div`
  padding: 4px 0;
  color: #4a4a4a;
  font-size: 16px;
  font-weight: 400;
`;

// Details Button
export const DetailsButton = styled.button`
  margin-left: auto;
  margin-top: 20px;
`;

// Arrow
export const Arrow = styled.div`
  border: solid #4a4a4a;
  border-width: 0 1.5px 1.5px 0;
  padding: 3px;
`;

// Up Arrow
export const UpArrow = styled(Arrow)`
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
`;

// Down Arrow
export const DownArrow = styled(Arrow)`
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
`;

// Things To Remember
export const ThingsToRemember = styled.div`
  padding: 32px 200px;
  background: #16477f;
`;

// Know More
export const KnowMore = styled.div`
  padding: 24px 200px;
`;

// Know More Title
export const KnowMoreTitle = styled.h2`
  font-size: 24px;
  font-weight: 900;
  color: #000000;
`;

// Know More Section
export const KnowMoreSection = styled.div`
  overflow: auto;
  margin: 20px 0;
`;

// Know More Window
export const KnowMoreWindow = styled.div`
  display: flex;
`;

// Inbound Call Box
export const InboundCallBox = styled.div`
  margin-left: auto;
`;

// Know More Card
export const KnowMoreCard = styled.div`
  display: grid;
  width: 330px;
  margin-right: 20px;
  
  &:hover {
    cursor: pointer;
  }
`;

// Know More Image
export const KnowMoreImg = styled.img`
  width: 330px;
`;

// MC Title
export const McTitle = styled.h3`
  padding: 0;
  font-size: 22px;
  font-weight: 800;
  color: black;
  margin-right: 5px;
`;

// Dham Text
export const DhamText = styled.p`
  font-size: 14px;
  padding: 5px 8px;
  font-weight: 400;
  color: #757575;
`;

// Stop Text
export const StopText = styled.p`
  font-weight: 400;
  padding: 5px 8px;
  font-size: 14px;
`;

// Stop Points
export const StopPoints = styled.div`
  font-size: 16px;
  font-weight: 400;
  padding: 0 20px;
`;

// Box Selector
export const BoxSelector = styled.div`
  border: 1px solid #d8d8d8;
  background: white;
  border-radius: 8px;
  display: flex;
  padding: 8px 16px;
  align-items: center;
`;

// Box Container
export const BoxContainer = styled.div`
  padding: 0 16px;
  border-radius: 8px;
  background: white;
  border: 1px solid #d8d8d8;
  display: flex;
  margin: 16px 0;
`;

// Box Info
export const BoxInfo = styled.div`
  padding-left: 16px;
  width: 100%;
`;

// Box Image
export const BoxImg = styled.img`
  width: 100px;
  height: 80px;
`;

// Box Label
export const BoxLabel = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: black;
`;

// Itinerary Cards Container
export const ItineraryCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
`;

// Itinerary Card
export const ItineraryCard = styled.div`
  width: 300px;
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

// Itinerary Card Title
export const ItineraryCardTitle = styled.h4`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 8px;
`;

// Itinerary Card Text
export const ItineraryCardText = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a4a;
`;

// Itinerary Card Button
export const ItineraryCardButton = styled.button`
  background: linear-gradient(91.67deg, #53b2fe 0%, #065af3 100%);
  color: white;
  border-radius: 8px;
  padding: 8px 16px;
  border: none;
  font-size: 14px;
  font-weight: 700;
  
  &:hover {
    cursor: pointer;
  }
`;

export const PrimaryButton = styled.button`
  background: #0066cc;
  color: white;
  border-radius: 8px;
  padding: 10px 20px;
  border: none;
  font-size: 16px;
  font-weight: 700;
  
  &:hover {
    cursor: pointer;
  }
`;

export const SecondaryButton = styled.button`
  background: #f0f0f0;
  color: #333;
  border-radius: 8px;
  padding: 10px 20px;
  border: 1px solid #ddd;
  font-size: 16px;
  font-weight: 700;
  
  &:hover {
    cursor: pointer;
  }
`;
